import { concat } from '@ember/helper';
import Component from '@glimmer/component';
import optional from '@nullvoxpopuli/ember-composable-helpers/helpers/optional';
import { t } from 'ember-intl';

import BvSelect from 'volta/components/bv-select';
import BvTag from 'volta/components/bv-tag';
import BvText from 'volta/components/bv-text';

export const ComparatorsSigns: Record<TComparator, string> = {
  eq: '=',
  in: '∈',
  ni: '∉',
  ne: '≠',
  gt: '>',
  lt: '<',
  bt: '[]',
  lk: '≈',
  any: '∈',
  all: '=',
  is_empty: '∅'
};

export type TComparatorOption = {
  sign: string;
  label: string;
  key: TComparator;
};

interface FiltersComparatorSelectSignature {
  Args: {
    comparators: TComparator[];
    selected?: TComparator;
    onChange?: (comparator: TComparatorOption) => void;
    name?: string;
  };
  Element: HTMLDivElement;
}

export default class FiltersComparatorSelectComponent extends Component<FiltersComparatorSelectSignature> {
  get comparatorOptions(): TComparatorOption[] {
    const { comparators } = this.args;
    return comparators.map((comparator) => {
      return {
        key: comparator,
        sign: ComparatorsSigns[comparator],
        label: `comparators.${comparator}`
      };
    });
  }

  get selectedComparatorOption() {
    return this.comparatorOptions.find((c) => c.key === this.args.selected);
  }

  <template>
    <div class='filter-item__comparators u-flex-shrink-0' ...attributes>
      <BvSelect
        @plain={{true}}
        @options={{this.comparatorOptions}}
        @selected={{this.selectedComparatorOption}}
        @matchTriggerWidth={{false}}
        @onChange={{optional @onChange}}
        @dataName={{concat 'comparator-' @name}}
        @triggerClass='u-full-width'
        as |comparatorOption|
      >
        <BvTag @size='sm' class='comparator-sign' title={{t comparatorOption.label}}>
          <BvText @fontWeight='semibold' @text={{comparatorOption.sign}} class='u-text-mono' />
        </BvTag>
        <span class='comparator-label u-ml-2 u-ellipsis'>
          {{t comparatorOption.label}}
        </span>
      </BvSelect>
    </div>
  </template>
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Filters::ComparatorSelect': typeof FiltersComparatorSelectComponent;
    'filters/comparator-select': typeof FiltersComparatorSelectComponent;
  }
}
